
export default class Geometry{
    constructor(params){
        this.type = 'Point';
        this.coordinates = [params.x,params.y];
    }
}
